// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 将完成流程另存模板 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/processTemplate/v1/fromProcess */
export async function createBossProcessTemplateFromProcess(
  body: CoreAPI.ActivityProcessFromProcessRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessTemplateDetail>(
    '/bossApi/conference/core/processTemplate/v1/fromProcess',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询流程模板版本 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/processTemplate/v1/get */
export async function getBossProcessTemplate(
  body: CoreAPI.ActivityProcessTemplateRefRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessTemplateDetail>(
    '/bossApi/conference/core/processTemplate/v1/get',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询流程模板 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/processTemplate/v1/page */
export async function pageBossProcessTemplates(
  body: CoreAPI.ActivityProcessPageRequestRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessPageActivityProcessTemplateDetail>(
    '/bossApi/conference/core/processTemplate/v1/page',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 发布流程模板版本 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/processTemplate/v1/publish */
export async function publishBossProcessTemplate(
  body: CoreAPI.ActivityProcessTemplateRefRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessTemplateDetail>(
    '/bossApi/conference/core/processTemplate/v1/publish',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 保存流程模板草稿 按当前身份及资源授权处理，写操作按业务请求标识去重 POST /bossApi/conference/core/processTemplate/v1/saveDraft */
export async function saveBossProcessTemplateDraft(
  body: CoreAPI.ActivityProcessSaveTemplateRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseActivityProcessTemplateDetail>(
    '/bossApi/conference/core/processTemplate/v1/saveDraft',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
